import React, { useEffect } from "react";
import ConnectWithUs from "./ConnectWithUs";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ContactUs.css";

const ContactUs = () => {
  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  return (
    <div>
      <h1 className="contact-us" data-aos="fade-down">
        <span className="contact-title-text">Get In Touch</span>
      </h1>
      <ConnectWithUs />
    </div>
  );
};

export default ContactUs;
